import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07cd5fa6&scoped=true&lang=pug"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=07cd5fa6&prod&lang=scss"
import style1 from "./style.scss?vue&type=style&index=1&id=07cd5fa6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd5fa6",
  null
  
)

export default component.exports